import { useCallback, useEffect, useMemo, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import appUserService from '../services/appUserService'
import { smartParseParam, encodeLink } from '../helper/params'
import PaymentService from '../services/paymentService'
import { PAYMENT_NEW, PAYMENT_SUCCESS } from '../constants/payment'
import { useAppParamsContext } from '../context/AppParamsContext'
import { PATH } from '../constants/router'
import { getUsernamePrefix } from './useVehicleList'
import { PAYMENT_QR_METHOD, PAYMENT_TYPE } from '../constants/global'
import { useAppUserContext } from '../context/AppUserContext'

export const ERROR_PROMOTION_CODE = {
  PROMOTION_CODE_NOT_EXIST: 'Mã giảm giá không chính xác!',
  PROMOTION_EXPIRED: 'Mã giảm giá đã hết hạn!',
  PROMOTION_NOT_ELIGIBLE: 'Không đủ điều kiện sử dụng mã giảm giá!'
}
const ERROR_CREATE_PAYMENT = {
  UNCONFIRMED_BOOKING_EXISTED: 'Phương tiện của quý khách đã đăng ký thông báo phạt nguội. Vui lòng kiểm tra lại!',
  MAX_LIMIT_SCHEDULE_BY_USER: 'Bạn đã đặt giới hạn số đơn hàng cho phép. Vui lòng liên hệ hỗ trợ để được giải quyết.',
  ORDER_NOT_FOUND: 'Đơn hàng không tồn tại!',
  USER_NOT_FOUND: 'Người dùng không tồn tại!',
  CREATE_PAYMENT_FAILED: 'Tạo đơn hàng thanh toán không thành công!',
  NO_LINK_ACCOUNT_WITH_VTM: 'Chưa liên kết tài khoản ViettelMoney!',
  UNAVAILABLE_BALANCE: 'Số dư không khả dụng!',
  PAYMENT_FAILED: 'Thanh toán thất bại!'
}

export const convertListLicensePlates = (vehicles) => vehicles?.map((v) => (typeof v === 'string' ? v : v.plate)) || []
export const convertListProductIds = (services = []) =>
  services?.map((s) => (Number(s?.productSize) > 0 ? { productId: s.productId, quantity: 1 } : s.productId))
const useAutomatedTrafficFineNotificationPayment = () => {
  const location = useLocation()
  const locationState = location?.state || {}
  const { userData } = useAppUserContext()
  const passedPhoneWithPrefix = userData?.phoneNumberWithUsernamePrefix || locationState?.phoneNumberWithUsernamePrefix || ''

  const orderIdFromUrl = useMemo(() => {
    const urlParams = new URLSearchParams(location.search)
    return urlParams.get('orderId')
  }, [location.search])

  const [isPageLoading, setIsPageLoading] = useState(true)
  const [orderDetail, setOrderDetail] = useState(null)
  const [vehicles, setVehicles] = useState(location?.state?.vehicles || [])
  const [services, setServices] = useState(location?.state?.services || [])
  const [email] = useState(location?.state?.email || undefined)

  const [isSubmitting, setIsSubmitting] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)

  const [paymentCalculated, setPaymentCalculated] = useState({})
  const [paymentMethod, setPaymentMethod] = useState(null)
  const [promotionCodeApplied, setPromotionCodeApplied] = useState(null) // Áp dụng thành công
  const [promotionCode, setPromotionCode] = useState(null) //Chỉ để hiển thị cho input
  const [isLoadingPromotionCode, setIsLoadingPromotionCode] = useState(false)
  const [errorPromotionCode, setErrorPromotionCode] = useState(null)

  const [confirmTerm, setConfirmTerm] = useState(false)

  const [isOpenQrCodePayment, setIsOpenQrCodePayment] = useState(false)
  const [paymentDetail, setPaymentDetail] = useState([])

  const { hidePaymentMethod } = useAppParamsContext()

  const history = useHistory()

  const getOrderDetailData = useCallback(
    async (orderId) => {
      try {
        const orderResult = await appUserService.getOrderDetail({ id: orderId })
        if (orderResult?.statusCode === 200 && orderResult?.data) {
          const orderDetail = orderResult.data
          if (orderDetail?.paymentStatus !== PAYMENT_NEW) {
            history.replace(PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_INTRODUCE)
            return
          }
          setOrderDetail(orderDetail)
          // trong orderDetail có tiền luôn rồi
          setPaymentCalculated(orderDetail)
          const { services, vehicles } = extractServicesAndVehiclesInOrderDetail(orderDetail?.orderItems || [])
          setServices(services)
          setVehicles(vehicles)
        }
      } catch (error) {}
    },
    [history]
  )

  const calculatePayment = useCallback(async (payload) => {
    try {
      const result = await PaymentService.calculatePaymentInfo(payload)
      if (result?.statusCode === 200 && result?.data) {
        setPaymentCalculated(result.data)
      } else {
      }
      setIsSubmitting(false)
    } catch (error) {
      setIsSubmitting(false)
    }
  }, [])

  useEffect(() => {
    if (!orderIdFromUrl) return
    // Truong hop co order id
    const loadOrderDetail = async () => {
      try {
        setIsPageLoading(true)
        await getOrderDetailData(orderIdFromUrl)
      } finally {
        setIsPageLoading(false)
      }
    }
    loadOrderDetail()
  }, [orderIdFromUrl, getOrderDetailData])

  useEffect(() => {
    if (orderIdFromUrl) return
    // Ko co order id thi mac dinh goi de tinh tien
    const loadCalculatedPayment = async () => {
      try {
        setIsPageLoading(true)
        await calculatePayment({
          licensePlatesList: convertListLicensePlates(vehicles),
          productIds: convertListProductIds(services)
        })
      } finally {
        setIsPageLoading(false)
      }
    }
    loadCalculatedPayment()
  }, [orderIdFromUrl, vehicles, services, calculatePayment])

  const handleCheckAuthenticationLinked = async (createdOrderId) => {
    // Check true khi mà ko có key nào thỏa, buộc set lại false khi thỏa điều kiện check
    let linked = true
    setIsSubmitting(true)
    if (smartParseParam(process.env.REACT_APP_MINIAPP_VIETTEL_MONEY)) {
      linked = false
      const linkedViettelMoneyRes = await appUserService.viettelMoneyAPIInitializeLink({
        username: `${getPhoneNumberWithPrefix(null, passedPhoneWithPrefix)}`,
        orderId: createdOrderId
      })
      if (linkedViettelMoneyRes?.statusCode === 200) {
        if (linkedViettelMoneyRes?.data?.isLinked) {
          linked = true
          setIsSubmitting(false)
        } else if (linkedViettelMoneyRes?.data?.deepLink) {
          window.location.href = linkedViettelMoneyRes.data.deepLink
          return
        }
      } else {
        setIsSubmitting(false)
        setErrorMessage({ title: 'Liên kết thất bại', content: 'Liên kết thất bại, vui lòng thử lại' })
      }
    }
    return linked
  }

  const handlePayment = async () => {
    try {
      if (isSubmitting) return

      // nếu có orderDetail thì lấy orderId từ đó, không thì tạo order mới
      let customerScheduleId = orderDetail?.orderId

      if (!customerScheduleId) {
        const paymentMethodDataForCreateOrder = checkPaymentMethodForCreateOrder(paymentMethod)
        const payloadCreateOrder = {
          email: email,
          licensePlatesList: convertListLicensePlates(vehicles),
          productIds: convertListProductIds(services),
          phoneNumber: getPhoneNumberWithPrefix(orderDetail, passedPhoneWithPrefix),
          requestId: `REQ-${Date.now()}`,
          allowRenew: checkAutoRenewForCreateOrder(),
          promotionCode: promotionCodeApplied || undefined,
          vehicleType: vehicles?.[0]?.vehicleType,
          ...paymentMethodDataForCreateOrder
        }

        setIsSubmitting(true)
        const orderResult = await appUserService.createOrderAutoNoty(payloadCreateOrder)
        setIsSubmitting(false)

        if (orderResult?.statusCode !== 200 || !orderResult?.data) {
          if (orderResult?.error && ERROR_CREATE_PAYMENT?.[orderResult?.error]) {
            return setErrorMessage({ title: 'Thanh toán thất bại', content: ERROR_CREATE_PAYMENT?.[orderResult?.error] })
          }
          return setErrorMessage({ title: 'Thanh toán thất bại', content: 'Có lỗi xảy ra khi tạo đơn thanh toán. Vui lòng thử lại.' })
        }
        customerScheduleId = orderResult?.data?.orderId
      }

      const linked = await handleCheckAuthenticationLinked(customerScheduleId)
      if (!linked) {
        return
      }

      // ====== CREATE PAYMENT (dùng chung cho cả 2 case) ======
      const cancelDataObj = {
        redirectUrl: PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_PAYMENT,
        params: { orderId: customerScheduleId }
      }
      const encodedCancelData = encodeLink(JSON.stringify(cancelDataObj))

      const payloadCreatePayment = {
        customerScheduleId,
        paymentMethodOptions: {
          returnUrl: `${window.location.origin}${PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_PAYMENT_SUCCESS}?orderIdSuccess={{orderId}}`,
          cancelUrl: `${window.location.origin}${PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_REDIRECT_HANDLER}?redirectData=${encodedCancelData}`
        },
        ...checkPaymentMethodForPayment(paymentMethod, orderDetail)
      }

      setIsSubmitting(true)
      const paymentResponse = await appUserService.createPayment(payloadCreatePayment)
      setIsSubmitting(false)

      if (paymentResponse?.statusCode !== 200 || !paymentResponse?.data) {
        if (paymentResponse?.error && ERROR_CREATE_PAYMENT?.[paymentResponse?.error]) {
          return setErrorMessage({ title: 'Thanh toán thất bại', content: ERROR_CREATE_PAYMENT?.[paymentResponse?.error] })
        }
        return setErrorMessage({ title: 'Thanh toán thất bại', content: 'Có lỗi xảy ra khi thanh toán. Vui lòng thử lại.' })
      }

      setPaymentDetail(paymentResponse?.data)

      const link = paymentResponse?.data?.paymentLinkUrl
      if (link?.startsWith('https://')) {
        window.location.href = link
        return
      }

      if (paymentResponse?.data?.paymentStatus === PAYMENT_SUCCESS) {
        history.push(PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_SUCCESS?.replace(':id', customerScheduleId))
      } else if (paymentResponse?.data?.paymentStatus === PAYMENT_NEW) {
        setIsOpenQrCodePayment(true)
      } else {
        return setErrorMessage({ title: 'Thanh toán thất bại', content: 'Có lỗi xảy ra khi thanh toán. Vui lòng thử lại.' })
      }
    } catch (error) {}
  }

  const calculatePaymentWithPromotion = async (resetPromotionCode = false) => {
    setIsLoadingPromotionCode(true)
    const result = await PaymentService.calculatePaymentInfo({
      licensePlatesList: convertListLicensePlates(vehicles),
      productIds: convertListProductIds(services),
      promotionCode: resetPromotionCode ? undefined : promotionCode
    })
    setIsLoadingPromotionCode(false)
    if (result?.statusCode === 200 && result?.data) {
      setPaymentCalculated(result.data)
      setPromotionCodeApplied(promotionCode)
    } else {
      if (ERROR_PROMOTION_CODE?.[result?.error]) {
        setErrorPromotionCode(ERROR_PROMOTION_CODE?.[result?.error])
      } else {
        setErrorPromotionCode('Mã giảm giá không chính xác!')
      }
    }
  }

  const handleChangePromotionCode = (e) => {
    const value = e.target.value.trim()
    setPromotionCode(value)
    setErrorPromotionCode(null)
  }

  const getOrderDetailInterval = useCallback((id) => {
    appUserService.getOrderDetail({ id }).then((result) => {
      const { error, statusCode, data } = result
      if (statusCode === 200) {
        if (data?.paymentStatus === PAYMENT_SUCCESS) {
          history.push(PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_SUCCESS?.replace(':id', id))
          setIsOpenQrCodePayment(false)
        }
      }
    })
  }, [])

  useEffect(() => {
    if (!isOpenQrCodePayment || !paymentDetail?.customerScheduleId) return

    // Call once immediately, then poll.
    getOrderDetailInterval(paymentDetail.customerScheduleId)
    const timerInterval = setInterval(() => {
      getOrderDetailInterval(paymentDetail.customerScheduleId)
    }, 5000)

    return () => clearInterval(timerInterval)
  }, [isOpenQrCodePayment, paymentDetail?.customerScheduleId, getOrderDetailInterval])

  const disabledPayBtn = useMemo(
    () =>
      // (!hidePaymentMethod && !confirmTerm) ||
      (!(hidePaymentMethod || orderDetail?.orderId) && !paymentMethod) ||
      isSubmitting ||
      vehicles.length === 0 ||
      isLoadingPromotionCode ||
      errorPromotionCode,
    [
      hidePaymentMethod,
      // confirmTerm,
      orderDetail?.orderId,
      paymentMethod,
      isSubmitting,
      vehicles.length,
      isLoadingPromotionCode,
      errorPromotionCode
    ]
  )

  return {
    isPageLoading,
    vehicles,
    services,
    promotionCode,
    paymentMethod,
    setPaymentMethod,
    isLoadingPromotionCode,
    errorPromotionCode,
    handleChangePromotionCode,
    calculatePaymentWithPromotion,
    paymentCalculated,
    confirmTerm,
    setConfirmTerm,
    handlePayment,
    isSubmitting,
    errorMessage,
    setErrorMessage,
    isOpenQrCodePayment,
    setIsOpenQrCodePayment,
    paymentDetail,
    disabledPayBtn,
    orderDetail
  }
}

export default useAutomatedTrafficFineNotificationPayment

export function extractServicesAndVehiclesInOrderDetail(items) {
  // 1) SERVICES (unique theo productId)
  const serviceMap = new Map() // key -> service

  for (const it of items) {
    const key = it.productId
    if (!serviceMap.has(key)) {
      serviceMap.set(key, { ...it })
    }
  }

  const services = [...serviceMap.values()]

  // 2) VEHICLES (unique theo plate)
  const plateSet = new Set()
  const vehicles = []

  for (const it of items) {
    // Prefer orderItemVehicle; fallback to orderItemValue.
    let plates = []

    try {
      const v = JSON.parse(it.orderItemVehicle || '{}')
      const vehicleIdentity = v?.vehicleIdentity
      if (Array.isArray(vehicleIdentity)) {
        plates = vehicleIdentity
      } else if (typeof vehicleIdentity === 'string') {
        plates = [vehicleIdentity]
      }
    } catch (_) {
      // ignore parse error
    }

    if (plates.length === 0) {
      const rawValue = it.orderItemValue
      let parsedValue = rawValue
      if (typeof rawValue === 'string') {
        const trimmed = rawValue.trim()
        if (
          (trimmed.startsWith('[') && trimmed.endsWith(']')) ||
          (trimmed.startsWith('{') && trimmed.endsWith('}')) ||
          (trimmed.startsWith('"') && trimmed.endsWith('"'))
        ) {
          try {
            parsedValue = JSON.parse(trimmed)
          } catch (_) {
            parsedValue = rawValue
          }
        }
      }

      if (Array.isArray(parsedValue)) {
        plates = parsedValue
      } else if (typeof parsedValue === 'string') {
        plates = [parsedValue]
      }
    }

    for (const plate of plates) {
      if (typeof plate !== 'string') continue
      const normalized = plate.trim()
      if (!normalized || plateSet.has(normalized)) continue
      plateSet.add(normalized)
      vehicles.push({ plate: normalized })
    }
  }

  return { services, vehicles }
}

function checkPaymentMethodForPayment(paymentMethod, orderDetail) {
  if (smartParseParam(process.env.REACT_APP_MINIAPP_VIETTEL_MONEY)) {
    return {
      paymentMethodType: PAYMENT_TYPE.VIETTEL_MONEY_GATEWAY,
      paymentMethodId: PAYMENT_QR_METHOD.VTMxTAMOVE_PAYMENT_METHOD_ID
    }
  }
  const paymentMethodId = paymentMethod?.paymentMethodId ?? orderDetail?.paymentMethodId
  const paymentMethodType = paymentMethod?.paymentMethodType ?? orderDetail?.paymentMethodType
  return {
    paymentMethodId,
    paymentMethodType
  }
}

function checkPaymentMethodForCreateOrder(paymentMethod) {
  if (smartParseParam(process.env.REACT_APP_MINIAPP_VIETTEL_MONEY)) {
    return {
      paymentMethodType: PAYMENT_TYPE.VIETTEL_MONEY_GATEWAY,
      paymentMethodId: PAYMENT_QR_METHOD.VTMxTAMOVE_PAYMENT_METHOD_ID
    }
  }
  return {
    paymentMethodId: paymentMethod?.paymentMethodId,
    paymentMethodType: paymentMethod?.paymentMethodType
  }
}

function checkAutoRenewForCreateOrder(paymentMethod) {
  if (smartParseParam(process.env.REACT_APP_MINIAPP_VIETTEL_MONEY)) {
    return 1
  }
  return 0
}

// Hàm này check số điện thoại với prefix
function getPhoneNumberWithPrefix(orderData, passedPhoneWithPrefix) {
  if (orderData?.phoneNumber) {
    return orderData.phoneNumber
  }
  return passedPhoneWithPrefix || ''
}
